import React from "react";
import Countdown from "react-countdown";
import moment from "moment";
import { t } from "../../../../../utils/i18n";

const TradeCountdown = ({
  tradeData,
  isSystemCancelled,
  isDisputed,
  acceptSuccess,
  isDisputedAllowed
}) => {
  return (
    <div className="tradecountdown-parent-cont">
      {tradeData?.external_status === "pending_payment" &&
      !isSystemCancelled ? (
        <div>
          <div className="tradecountdown-text">
            {t("p2p.countdown.expires")}{" "}
            <Countdown date={new Date(tradeData?.expired_at)} />
          </div>
        </div>
      ) : (
        <></>
      )}

      {tradeData?.external_status === "payment_paid" &&
      !isDisputed &&
      !acceptSuccess ? (
        <div>
          {!isDisputedAllowed() && (
            <div className="tradecountdown-text">
              {t("p2p.countdown.waiting")}{" "}
              <Countdown
                daysInHours={true}
                date={moment
                  .utc(tradeData?.paid_at)
                  .local()
                  .add(3, "hours")
                  .toDate()}
              />
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TradeCountdown;
